import React, { useEffect, useState } from "react";
import "./cookieConsent.css";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("kostpadi_cookie_consent");

    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("kostpadi_cookie_consent", "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <p>
          KostPadi uses cookies and similar technologies to improve your
          experience, analyze traffic, and enhance platform security. By
          continuing to use this platform, you consent to our use of cookies.
        </p>

        <button onClick={acceptCookies}>Accept</button>
      </div>
    </div>
  );
};

export default CookieConsent;
